import { motion } from "framer-motion";
import { useMemo, useState } from "react";
import { clientLogos } from "../data/clientLogos";
import { slowFadeUp } from "../utils/animations";
import "./LogoMarquee.css";

function ClientLogo({ name, location, logo }) {
  const [hasError, setHasError] = useState(!logo);

  return (
    <figure className="logo-marquee-card" title={`${name}, ${location}`}>
      {hasError || !logo ? (
        <div
          title={`${name}, ${location}`}
          className="logo-marquee-media logo-marquee-media--fallback"
        >
          <span className="logo-marquee-fallback-text">{name}</span>
        </div>
      ) : (
        <div title={`${name}, ${location}`} className="logo-marquee-media">
          <img
            src={logo}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setHasError(true)}
            className="logo-marquee-image"
          />
        </div>
      )}
      <figcaption className="logo-marquee-caption">
        <span className="logo-marquee-name">{name}</span>
        <span className="logo-marquee-region">{location}</span>
      </figcaption>
    </figure>
  );
}

export default function LogoMarquee({ clients = clientLogos, duration = 52 }) {
  const loopClients = useMemo(() => [...clients, ...clients], [clients]);

  return (
    <motion.div
      variants={slowFadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      className="logo-marquee group"
      style={{ "--logo-marquee-duration": `${duration}s` }}
    >
      <div
        className="pointer-events-none absolute inset-y-0 left-0 z-10 hidden w-20 bg-gradient-to-r from-slate-50 to-transparent md:block"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 z-10 hidden w-20 bg-gradient-to-l from-slate-50 to-transparent md:block"
        aria-hidden
      />

      <div className="logo-marquee-track">
        {loopClients.map((client, index) => (
          <div
            key={`${client.id}-${index}`}
            className="logo-marquee-item"
            aria-hidden={index >= clients.length || undefined}
          >
            <ClientLogo
              name={client.name}
              location={client.location}
              logo={client.logo}
            />
          </div>
        ))}
      </div>
    </motion.div>
  );
}
